import router from '@/router'
import { esAdminErp, normalizarPerfilRh } from '@/vendedora/constantes'

export default {
  namespaced: true,

  state: {
    accessToken: null,
    perfil: null,
    chatActivo: null,
  },

  mutations: {
    SET_SESION (state, { accessToken, perfil }) {
      state.accessToken = accessToken
      state.perfil = perfil
    },
    SET_CHAT_ACTIVO (state, chat) {
      state.chatActivo = chat
    },
    PATCH_CHAT_ACTIVO (state, patch) {
      if (!state.chatActivo) return
      state.chatActivo = { ...state.chatActivo, ...patch }
    },
    SALIR (state) {
      state.accessToken = null
      state.perfil = null
      state.chatActivo = null
    },
  },

  actions: {
    guardarSesion ({ commit, rootState }, row) {
      const perfil = normalizarPerfilRh(row)
      // Evitar mezcla con sesión alumno/teacher LMS (sin navegar)
      if (rootState.login) {
        commit('login/SALIR', null, { root: true })
      }
      commit('SET_SESION', {
        accessToken: perfil && perfil.accessToken,
        perfil,
      })
      router.push({ name: 'VendedoraListaChats' }).catch(() => {})
    },
    setChatActivo ({ commit }, chat) {
      commit('SET_CHAT_ACTIVO', chat)
    },
    patchChatActivo ({ commit }, patch) {
      commit('PATCH_CHAT_ACTIVO', patch)
    },
    /** Limpia token sin navegar (p. ej. al entrar como alumno LMS). */
    limpiarSesion ({ commit }) {
      commit('SALIR')
      try {
        sessionStorage.removeItem('lms_sesion_vendedora')
        sessionStorage.removeItem('lms_rh_sso_payload')
      } catch (e) { /* ignore */ }
    },
    salir ({ commit, dispatch }) {
      dispatch('limpiarSesion')
      router.push({ name: 'Login' }).catch(() => {})
    },
  },

  getters: {
    getLogeadoVendedora (state) {
      return !!state.accessToken
    },
    getPerfilVendedora (state) {
      return state.perfil
    },
    getAccessTokenVendedora (state) {
      return state.accessToken
    },
    getChatActivo (state) {
      return state.chatActivo
    },
    getIderp (state) {
      const p = state.perfil
      if (!p) return null
      const v = p.iderp != null ? p.iderp
        : (p.id_usuario != null ? p.id_usuario
          : (p.idusuario != null ? p.idusuario : null))
      if (v == null || v === '') return null
      const n = Number(v)
      return Number.isFinite(n) ? n : v
    },
    getEsAdminVendedora (state, getters) {
      return esAdminErp(getters.getIderp)
    },
  },
}
